import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
    selector: "fui-breadcrumb",
    styleUrls: ["./breadcrumb.component.scss"],
    templateUrl: "./breadcrumb.component.html"
})
export class FUIBreadcrumbComponent {
    @Input() title: string;
    @Input() link: string;
    @Input() showClose: boolean;
    @Output() removed$: EventEmitter<string>;


    constructor(){
        this.removed$ = new EventEmitter<string>();
    }

    /**
     * Remove the host element
     */
    remove(): void {
        this.removed$.emit(this.link);
    }
}
